import { useSelector } from '_common/hooks';

import BannerContent from './Banner';
import IntlErrorBoundary from '../IntlErrorBoundary/IntlErrorBoundary';

const NewVersionAvailableBanner = () => {
  const versionWarning = useSelector((state) => state.app.versionWarning);

  if (import.meta.env.MODE === 'test') {
    return null;
  }

  return (
    <IntlErrorBoundary
      fallbackType="banner"
      mockProps={{ isVisible: versionWarning.isOpen, variant: 'information' }}
    >
      <BannerContent />
    </IntlErrorBoundary>
  );
};

export default NewVersionAvailableBanner;
